import React, { Component } from "react";
import { Row, Col, Card, CardBody, CardTitle } from "reactstrap";
import "bootstrap/dist/js/bootstrap.bundle";
import { Link, useHistory } from "react-router-dom";
import { withTranslation } from "react-i18next";
// datatable related plugins
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import Select, { AriaOnFocus } from "react-select";
import AsyncSelect from "react-select/async";

import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import {
  getPartyApi,
  getGraderInwardStock,
  getUserByRoleId,
  getGraderStock,
  assignGraderToFillerInWardsRepeats,
} from "api";
import { map } from "lodash";
import moment from "moment/moment";
import RaisedButton from "components/Common/RaisedButton";

class FillerRepeatStock extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      totalSize: 10,
      sizePerPage: 10,
      isMenuOpen: false,
      status: "",
      partyId: "",
      factoryId: "",
      orderId: "",
      fromDate: moment().subtract(1,"week").format("YYYY-MM-DD"),
      toDate:  moment().format("YYYY-MM-DD"),
      orderList: [],
      stockList: [],
      partyList: [],
      fillerList: [],
      graderOfficeStockList: [],
      jangadId: "",
      dataEntryStatus: "",
    };
  }

  async componentDidMount() {
    const jangadList = await  assignGraderToFillerInWardsRepeats({
      page: 1,
      limit: 10,
      partyId: this.state.partyId,
      factoryId: JSON.parse(localStorage.getItem("authUser")).factoryId,
      orderId: this.state.orderId,
      fromDate: this.state.fromDate,
      toDate: this.state.toDate,
      fillerId: this.state.fillerId,
      dataEntryStatus: this.state.dataEntryStatus,
    });
     if(jangadList && jangadList.data){
      this.setState(
        {
          orderList: jangadList.data.assignGraderToFillerInWards,
        },
        () => console.log(this.state.assignGraderToFillerInWards)
      );
     }
   
    const partyList = await getPartyApi({
      page: null,
      limit: null,
      name: null,
      partyCode: null,
    });
    if (partyList && partyList.data && Array.isArray(partyList.data.parties)) {
      this.setState({ partyList: partyList.data.parties });
    }
    const grader = await getUserByRoleId("ROLE0000003");
    this.setState({
      partyList: partyList.data.parties,
    });
    const onMenuOpen = () =>
    this.setState({
      isMenuOpen: true,
    });
  const onMenuClose = () =>
    this.setState({
      isMenuOpen: false,
    });
    this.getStockList();
  }

  async getPartyList(inputValue) {
    const data = await getPartyApi({
      page: null,
      limit: null,
      name: null,
      partyCode: inputValue,
    });
    if(data && data.data){
      this.setState({
        partyList: data.data.parties,
      });
    }
   
    if (Array.isArray(data.data.parties))
      return [
        { label: "All", value: "" },
        ...data.data.parties.map(x => {
          return { label: x.partyCode, value: x.id };
        }),
      ];
    else return [];
  }

  async getStockList() {
    const graderList = await assignGraderToFillerInWardsRepeats({
      page: this.state.page,
      limit: this.state.sizePerPage,
      partyId: this.state.partyId,
      factoryId: JSON.parse(localStorage.getItem("authUser")).factoryId,
      orderId: this.state.orderId,
      fromDate: this.state.fromDate,
      toDate: this.state.toDate,
      fillerId: this.state.fillerId,
      dataEntryStatus: this.state.dataEntryStatus,
    });
    if(graderList && graderList.data){
      this.setState({
        totalSize: graderList.data.count,
        graderOfficeStockList: graderList.data.assignGraderToFillerInWards.length == 0 ? [
          {
            id: "0",
            jangad: {
              cycle: 0,
              weight: 0,
              pieces: 0,
              createdAt: "0",
              factory: {
                name: "0"
              }
            },
            dataEntryGraderUser: {
              name: "0"
            },
            processId : 0,
            mainJangad: {
              name: "0",
              party: {
                name: "0",
              },
            },
            stockDataEntryInWard: {
              srNo: 0,
              pieces: 0
            },
            partyName: "0",
            weight: 0,
            pieces: 0,
            cycle: 0,
            createdAt: "",
            updatedAt: "",
            fillerStatus: "P",
            assignGraderToFillerStock: null,
          },
        ] : graderList.data.assignGraderToFillerInWards,
      });
    }
    
  }

  async getJangadList(inputValue) {
    const data = await  assignGraderToFillerInWardsRepeats({
      page: 1,
      limit: 10,
      partyId: this.state.partyId,
      factoryId: JSON.parse(localStorage.getItem("authUser")).factoryId,
      orderId: this.state.orderId,
      fromDate: this.state.fromDate,
      toDate: this.state.toDate,
      fillerId: this.state.fillerId,
      dataEntryStatus: this.state.dataEntryStatus,
      name: inputValue
    });
    if(data && data.data){
      this.setState(
        {
          orderList: data.data.assignGraderToFillerInWards,
        },
        () => console.log(this.state.assignGraderToFillerInWards)
      );
    }
   
    if (Array.isArray(data.data.assignGraderToFillerInWards))
      return [
        { label: "All", value: "" },
        ...data.data.assignGraderToFillerInWards.map(x => {
          return { label: x.mainJangad.name, value: x.mainJangad.id };
        }),
      ];
    else return [];
  }
  getFilter() {
    return this.state.graderOfficeStockList.filter(x => {
      if (
        this.state.partyId == "" &&
        this.state.jangadId == "" &&
        this.state.dataEntryStatus == ""
      )
        return x;
      else if (
        this.state.partyId == "" &&
        this.state.jangadId == "" &&
        this.state.dataEntryStatus == x.dataEntryStatus
      )
        return x;
      else if (
        this.state.partyId == "" &&
        this.state.jangadId ==  x.id &&
        this.state.dataEntryStatus == ""
      )
        return x;
      else if (
        this.state.partyId == "" &&
        this.state.jangadId ==  x.id &&
        this.state.dataEntryStatus == x.dataEntryStatus
      )
        return x;
      else if (
        this.state.partyId == "" &&
        this.state.jangadId == "" &&
        this.state.dataEntryStatus == ""
      )
        return x;
      else if (
        this.state.partyId == "" &&
        this.state.jangadId == "" &&
        this.state.dataEntryStatus == x.dataEntryStatus
      )
        return x;
      else if (
        this.state.partyId == "" &&
        this.state.jangadId ==  x.id &&
        this.state.dataEntryStatus == ""
      )
        return x;
      else if (
        this.state.partyId == "" &&
        this.state.jangadId ==  x.id &&
        this.state.dataEntryStatus == x.dataEntryStatus
      )
        return x;
      else if (
        this.state.partyId == x.mainJangad.party.id &&
        this.state.jangadId == "" &&
        this.state.dataEntryStatus == ""
      )
        return x;
      else if (
        this.state.partyId == x.mainJangad.party.id &&
        this.state.jangadId == "" &&
        this.state.dataEntryStatus == x.dataEntryStatus
      )
        return x;
      else if (
        this.state.partyId == x.mainJangad.party.id &&
        this.state.jangadId ==  x.id &&
        this.state.dataEntryStatus == ""
      )
        return x;
      else if (
        this.state.partyId == x.mainJangad.party.id &&
        this.state.jangadId ==  x.id &&
        this.state.dataEntryStatus == x.dataEntryStatus
      )
        return x;
      else if (
        this.state.partyId == x.mainJangad.party.id &&
        this.state.jangadId == "" &&
        this.state.dataEntryStatus == ""
      )
        return x;
      else if (
        this.state.partyId == x.mainJangad.party.id &&
        this.state.jangadId == "" &&
        this.state.dataEntryStatus == x.dataEntryStatus
      )
        return x;
      else if (
        this.state.partyId == x.mainJangad.party.id &&
        this.state.jangadId ==  x.id &&
        this.state.dataEntryStatus == ""
      )
        return x;
      else if (
        this.state.partyId == x.mainJangad.party.id &&
        this.state.jangadId ==  x.id &&
        this.state.dataEntryStatus == x.dataEntryStatus
      )
        return x;
    });
  }


//   getFilter() {
//     return this.state.graderOfficeStockList.filter(x => {
//       if (this.state.partyId == "" && this.state.jangadId == "") return x;
//       else if (this.state.partyId == "" && this.state.jangadId == x.id)
//         return x;
//       else if (this.state.partyId == x.partyId && this.state.jangadId == "")
//         return x;
//       else if (this.state.partyId == x.partyId && this.state.jangadId == x.id)
//         return x;
//     });
//   }
  render() {
    const promiseOptions = inputValue =>
    new Promise(resolve => {
      setTimeout(() => {
        resolve(this.getPartyList(inputValue));
      }, 0);
    });
    const promiseOptionsFiller = inputValue =>
    new Promise(resolve => {
      setTimeout(() => {
        resolve(this.getFillerList(inputValue));
      }, 0);
    });
  const promiseOptionsOrder = inputValue =>
    new Promise(resolve => {
      setTimeout(() => {
        resolve(this.getJangadList(inputValue));
      }, 0);
    });

    this.status = [
      { label: "All", value: "" },
      { label: "Assign", value: "A" },
      { label: "Notassign", value: "NA" },
    ];
    this.columns1 = [
      {
        dataField: "mainJangadId",
        text: `${this.props.t("Jangad Id")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.mainJangad.name;
        },

      },
      {
        dataField: "partyCode",
        text: `${this.props.t("Party Code")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.mainJangad.party.partyCode;
        },
      },
      {
        dataField: "srNo",
        text: `${this.props.t("Sr.No.")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.stockDataEntryInWard.srNo;
        },
      },
      {
        dataField: "pieces",
        text: `${this.props.t("Pieces")}`,
        sort: true,
        formatter(cell, row) {
          return row.stockDataEntryInWard.pieces;
        },
      },
      {
        dataField: "weight",
        text: `${this.props.t("Weight")}`,
        sort: true,
        formatter(cell, row) {
          return cell;
        },
      },
     
      {
        dataField: "cycle",
        text: `${this.props.t("Cycle")}`,
        formatter(cell, row) {
          return cell;
        },
      },
      {
        dataField: "processId",
        text: `${this.props.t("Process")}`,
        formatter(cell, row) {
          return row.process?.name;
        },
      },
      {
        dataField: "createdAt",
        text: `${this.props.t("Inward Date")}`,
        formatter(cell, row) {
          return moment(cell).format("DD/MM/YYYY");
        },
        sort: true,
        
      },
    ];

    const defaultSorted = [
      {
        dataField: "id",
        order: "asc",
      },
    ];

    const pageOptions = {
      paginationSize: 5,
      pageStartIndex: 1,
      firstPageText: "First",
      prePageText: "Back",
      nextPageText: "Next",
      lastPageText: "Last",
      nextPageTitle: "First page",
      prePageTitle: "Pre page",
      firstPageTitle: "Next page",
      lastPageTitle: "Last page",
      onPageChange: (page, limit) => {
        this.setState({ page: page }, () => this.getStockList());
      },
      sizePerPageOptionRenderer: ({ text, page, onSizePerPageChange }) => {
        return (
          <li key={text} role="presentation" className="dropdown-item">
            <a
              href="#"
              className="text-dark"
              tabIndex="-1"
              role="menuitem"
              data-page={page}
              onMouseDown={e => {
                onSizePerPageChange(page);
                this.setState({ page: 1, sizePerPage: page }, () =>
                  this.getStockList()
                );
              }}
            >
              {text}
            </a>
          </li>
        );
      },
      sizePerPageList: [10, 25, 50, 100],
      page: this.state.page,
      totalSize: this.state.totalSize,
      custom: true,
    };

    const { SearchBar } = Search;

    //meta title
    document.title = "grader flow";

    return (
      <PaginationProvider
        pagination={paginationFactory(pageOptions)}
        keyField="id"
        columns={this.columns1}
        data={this.state.graderOfficeStockList}
      >
        {({ paginationProps, paginationTableProps }) => (
          <ToolkitProvider
            keyField="id"
            columns={this.columns1}
            data={this.state.graderOfficeStockList}
            search
          >
            {toolkitProps => (
              <React.Fragment>
                <div className="page-content">
                  <div className="container-fluid">
                    <h3 className="text-black fw-bold text-uppercase">
                      {this.props.t("Repeat Stock List")}
                    </h3>
                    <Row>
                      <Col className="col-12 mt-3">
                        <Card>
                          <CardBody>
                            <div className="d-xxl-flex d-block justify-content-between text-center text-xxl-start">
                              <div className="">
                                <h4 className="text-black fw-bold">
                                  {this.props.t("Repeat Stock List")}
                                </h4>
                              </div>
                              <div className="pt-3 pt-xxl-0">
                                <label
                                  htmlFor="date"
                                  className="fs-5 fw-bold text-black pe-3"
                                >
                                  {this.props.t("From Date")}:
                                </label>
                                <input
                                  type="date"
                                  className="fs-5 text-black border-0"
                                  value={this.state.fromDate}
                                  name="date"
                                  onChange={e =>
                                    this.setState(
                                      { fromDate: e.target.value },
                                      () => this.getStockList()
                                    )
                                  }
                                />
                                <label
                                  htmlFor="date"
                                  className="fs-5 fw-bold px-0 px-md-3 text-black"
                                >
                                  {this.props.t("To Date")}:
                                </label>
                                <input
                                  type="date"
                                  className="fs-5 text-black border-0"
                                  name="date"
                                  value={this.state.toDate}
                                  onChange={e =>
                                    this.setState(
                                      { toDate: e.target.value },
                                      () => this.getStockList()
                                    )
                                  }
                                />
                              </div>
                              <div className="pt-3 pt-xxl-0">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <label
                                      htmlFor="search"
                                      className="pt-2 fs-5 pe-1 pe-lg-3"
                                    >
                                      {this.props.t("Select Party")}
                                    </label>
                                    <AsyncSelect
                                      id="partyId"
                                      className="officestock-select d-inline-block"
                                      onChange={e => {
                                        this.setState(
                                          {
                                            partyId: e.value,
                                            stockList: [],
                                            page: 1,
                                            sizePerPage: 10,
                                          },
                                          () => this.getStockList()
                                        );
                                      }}
                                      
                                      loadOptions={promiseOptions}
                                      defaultOptions={[
                                        { label: "All", value: "" },
                                        ...this.state.partyList.map(x => {
                                          return {
                                            value: x.id,
                                            label: x.partyCode,
                                          };
                                        }),
                                      ]}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="d-xxl-flex d-block text-center text-xxl-start justify-content-between">
                              <div>
                                <div className="pt-3 pt-xxl-0">
                                  <p className="d-inline pe-3 fs-5">
                                    {this.props.t("Show")}
                                  </p>
                                  <div className="d-inline">
                                    <SizePerPageDropdownStandalone
                                      className=""
                                      {...paginationProps}
                                    />
                                  </div>

                                  <p className="d-inline ps-3 fs-5">
                                    {this.props.t("entries")}
                                  </p>
                                </div>
                              </div>

                              {/* <div className="pt-3 pt-xxl-0">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <label
                                      htmlFor="search"
                                      className="pt-2 fs-5 pe-1 pe-lg-3"
                                    >
                                      {this.props.t("Stock ID")}
                                    </label>
                                    <select
                                      className="officestock-select"
                                      onChange={e => {
                                        this.setState({
                                          jangadId: e.target.value,
                                        }, () => this.getStockList());
                                      }}
                                    >
                                      <option value="">ALL</option>
                                      {this.state.graderOfficeStockList?.map(
                                        x => (
                                          <option
                                            key={"1" + x.id + "1"}
                                            value={x.id}
                                          >
                                            {x.id}
                                          </option>
                                        )
                                      )}
                                    </select>
                                  </div>
                                </div>
                              </div> */}

                              <div className="pt-3 pt-xxl-0">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <label
                                      htmlFor="search"
                                      className="pt-2 fs-5 pe-1 pe-lg-3"
                                    >
                                      {this.props.t("Search Jangad")}
                                    </label>
                                    <AsyncSelect
                                      id="jangadId"
                                      className="officestock-select d-inline-block"
                                      onChange={e => {
                                        this.setState(
                                          {
                                            orderId: e.value,
                                            stockList: [],
                                            page: 1,
                                            sizePerPage: 10,
                                          },
                                          () => {
                                            if(e.value == "") {
                                              this.getJangadList(null)
                                            }
                                            this.getStockList();
                                          }
                                        );
                                      }}
                                      
                                      loadOptions={promiseOptionsOrder}
                                      defaultOptions={[
                                        { label: "All", value: "" },
                                        ...this.state.orderList.map(x => {
                                          return {
                                            label: x.mainJangad.name,
                                            value: x.mainJangad.id,
                                          };
                                        }),
                                      ]}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>

                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    remote={true}
                                    keyField={"id"}
                                    responsive
                                    bordered={false}
                                    striped={false}
                                    defaultSorted={defaultSorted}
                                    onTableChange={() => false}
                                    data={this.state.inwardDataEntryStockList}
                                    columns={this.columns1}
                                    classes={"table align-middle table-nowrap"}
                                    headerWrapperClasses={"thead-light"}
                                    {...toolkitProps.baseProps}
                                    {...paginationTableProps}
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Col className="inner-custom-pagination mt-4 d-flex justify-content-between">
                              <div className="">
                                <h5>
                                  {this.props.t("Showing")}{" "}
                                  {(this.state.page - 1) *
                                    this.state.sizePerPage +
                                    1}{" "}
                                  -{" "}
                                  {this.state.totalSize < this.state.sizePerPage
                                    ? this.state.totalSize
                                    : this.state.sizePerPage *
                                        this.state.page >=
                                      this.state.totalSize
                                    ? this.state.totalSize
                                    : this.state.sizePerPage *
                                      this.state.page}{" "}
                                  of {this.state.totalSize}
                                </h5>
                              </div>
                              <div className="ms-auto">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </div>
                            </Col>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </div>
                </div>
              </React.Fragment>
            )}
          </ToolkitProvider>
        )}
      </PaginationProvider>
    );
  }
}
export default withTranslation()(FillerRepeatStock);
